export function getChannelType() {
  throw new Error('Web push notifications not yet supported');
}

export function updatePinpointDataIfNeeded(): Promise<void> {
  return Promise.resolve();
}
